import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/atoms/Skeleton/styles.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/pages/Noticias/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["breakpointDesktopDefault"] */ "/vercel/path0/src/hooks/useBreakpoint.ts");
